import Signin from '../auth/signin';
import DonarPublicPage from '../components/DonarPublicPage/DonarPublicPage';
import PublicPage from '../components/PublicPage/PublicPage';
import EventPublicRegistration from '../components/Events/EventPublicRegistration';
import ThankyouPage from '../components/ThankyouPage/ThankyouPage';
import AccommodationForm from '../components/Accommodation/AccommodationForm';
import AccommodationFormStepTwo from '../components/Accommodation/AccommodationFormStepTwo';
import PaymentSuccessPage from '../components/ThankyouPage/PaymentSuccessPage';
import DonationMahotsav from '../components/PublicPage/DonationMahotsav';
import DonationMahotsavType from '../components/PublicPage/DonationMahotsavType';
// Authentication

export const authRoutes = [
  { path: `${process.env.PUBLIC_URL}/login`, Component: <Signin /> },
  {
    path: `${process.env.PUBLIC_URL}/donation/:orgId/:templeUuid/:trustUuid/:bankId/*`,
    Component: <PublicPage />
  },
  {
    path: `${process.env.PUBLIC_URL}/mahotsav-donation/:orgId/:templeUuid/:trustUuid/:bankId/*`,
    Component: <DonationMahotsav />
  },
    {
    path: `${process.env.PUBLIC_URL}/mahotsav-donation/:orgId/:templeUuid/:trustUuid/:bankId/:accontId/*`,
    Component: <DonationMahotsavType />
  },
    {
    path: `${process.env.PUBLIC_URL}/Thankyou/:orgId/:templeUuid/:trustUuid/:bankId/:accontId`,
    Component: <ThankyouPage />
  },
  {
    path: `${process.env.PUBLIC_URL}/DonarPage/:orgId/:templeUuid`,
    Component: <DonarPublicPage />
  },
  {
    path: `${process.env.PUBLIC_URL}/EventRegister`,
    Component: <EventPublicRegistration />
  },
  {
    path: `${process.env.PUBLIC_URL}/Thankyou/:orgId/:templeUuid/:trustUuid/:bankId`,
    Component: <ThankyouPage />
  },
  {
    path: `${process.env.PUBLIC_URL}/Thankyou/:orgId/:templeUuid`,
    Component: <ThankyouPage />
  },
  {
    path: `${process.env.PUBLIC_URL}/accommodation/:orgId/:templeUuid/:trustUuid`,
    Component: <AccommodationForm />
  },
  {
    path: `${process.env.PUBLIC_URL}/accommodation/:orgId/:templeUuid/:trustUuid/:personId`,
    Component: <AccommodationFormStepTwo />
  },
  {
    path: `${process.env.PUBLIC_URL}/accommodation/invite/:inviteToken`,
    Component: <AccommodationForm />
  },
  {
    path: `${process.env.PUBLIC_URL}/accommodation/invite/:inviteToken/:personId`,
    Component: <AccommodationFormStepTwo />
  },
  {
    path: `${process.env.PUBLIC_URL}/accommodation/Thankyou/:orgId/:templeUuid/:trustUuid/:razorpay_order_id`,
    Component: <PaymentSuccessPage />
  }
];
// /?/:accountId?/:amount

// ("orgId:- ");
// ("templeUuid:- ");
// ("trustUuid:- ");
// ("bankId:- ");
